// extracted by mini-css-extract-plugin
export default {"materialModal":"material-modal_materialModal__AkWH5"};